var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompliantIcon = function SvgCompliantIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D3E4BD",
    rx: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#7BB622",
    clipPath: "url(#compliant-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M23.333 23.334c.513 0 .93-.427.93-.953v-1.034c0-.252.097-.495.272-.673l.328-.337a.484.484 0 0 0 0-.673l-.328-.337a.96.96 0 0 1-.272-.674V17.62a.94.94 0 0 0-.93-.952M16.667 23.334a.94.94 0 0 1-.93-.953v-1.034a.96.96 0 0 0-.272-.673l-.328-.337a.484.484 0 0 1 0-.673l.328-.337a.96.96 0 0 0 .272-.674V17.62c0-.526.417-.952.93-.952"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18.333 20h.008m3.318 0h.007"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 8.333,
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "compliant-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 10h20v20H10z"
  })))));
};
export default SvgCompliantIcon;